module.exports = __webpack_public_path__ + "static/media/how-it-works-bg.ee132a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/how-it-works-bg.png
// module id = 413
// module chunks = 33